export const getBadgeInitials = (email: string): string => {
    if (!email || typeof email !== "string") {
        return "";
    }

    const namePart = email.split("@")[0];
    const firstNameChar = namePart.charAt(0);

    if (namePart.includes(".")) {
        const splitByDot = namePart.split(".");
        return (splitByDot[0].charAt(0) + splitByDot[1].charAt(0)).toUpperCase();
    }

    const camelCaseMatches = namePart.match(/[A-Z]/g);
    if (camelCaseMatches && camelCaseMatches.length > 0) {
        if (firstNameChar === camelCaseMatches[0] && camelCaseMatches.length > 1) {
            return (firstNameChar + camelCaseMatches[1]).toUpperCase();
        } else if (firstNameChar !== camelCaseMatches[0]) {
            return (firstNameChar + camelCaseMatches[0]).toUpperCase();
        }
    }

    if (namePart.includes("_") || namePart.includes("-")) {
        const separator = namePart.includes("_") ? "_" : "-";
        const splitName = namePart.split(separator);
        if (splitName.length > 1) {
            return (splitName[0].charAt(0) + splitName[1].charAt(0)).toUpperCase();
        }
    }

    return firstNameChar.toUpperCase();
};
